import { createFileRoute } from '@tanstack/react-router';
import { NewsletterSetupContentStep } from '@/pages/workspaces/broadcasts/newsletter/setup/content';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/setup/content',
)({ component: withRumPageRendered(NewsletterSetupContentStep) });
